import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'

export default RouteGroup({

  prefix: '/articles',

  routes: [
    Route('/:type', 'articles.index', view('articles/Index')),
    Route('/:type/create', 'article.create', view('articles/Create')),
    Route('/:type/:article/edit', 'article.edit', view('articles/Edit')),
  ]
})